import { CommonStore } from '../common-store';

const storeModule = new CommonStore(
  'camp/products',
  { name: 'camp.products.index' }
);

export default {
  namespaced: storeModule.namespaced,
  state: storeModule.state,
  getters: storeModule.getters,
  actions: storeModule.actions,
  mutations: storeModule.mutations
};
